module.exports = __webpack_public_path__ + "assets/media/apple-store.16d215a3.svg";